import { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Videos from '../components/videos';
import { Header } from '../components';
import { ProfileContext } from '../contexts/profileContext';
import { getCompleteGroupDetails, getProfileData, getProfileDetails } from '../service';
import { BackButtonIcon } from '../components/icons';

export default function ProfileVideos() {
  const { groupId, profileId } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [adminProfile] = useContext(ProfileContext);

  const [profile, setProfile] = useState(null);
  const [groupDetails, setGroupDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (adminProfile?.loaded) {
      fetchData();
    }
  }, [groupId, profileId, adminProfile]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const [{ data: profileDetails }, { data: groupData }] = await Promise.all([
        getProfileDetails(profileId),
        getCompleteGroupDetails(groupId)
      ]);
      setProfile({ ...profileDetails, _id: profileId });
      setGroupDetails(groupData);
    } catch (error) {
      toast.error('Failed to load data');
      console.error('Failed to load data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBack = () => {
    navigate(`/${groupId}/profiles/${profileId}`);
  };

  const name = profile ? `${profile.firstName} ${profile.familyName}` : '';

  return (
    <div className="App">
      <div className={'h-screen flex'}>
        <div className={'flex-1 min-w-0 bg-white flex flex-col'}>
          <Header />
          <div className="flex items-center gap-4 px-6 py-4 border-b pt-20">
            <button type="button" onClick={handleBack} className="cursor-pointer">
              <BackButtonIcon />
            </button>
            <p className="text-2xl font-semibold">
              {name}{' '}
              <span className="text-sm font-normal">
                {t('editProfileVideos.inGroup')}{' '}
                <span className="underline">{groupDetails?.name}</span>
              </span>
            </p>
          </div>
          <div className="flex-1 overflow-auto">
            {isLoading ? (
              <div className="flex items-center justify-center h-full p-10">
                <span>{t('common.loading', { defaultValue: 'Loading...' })}</span>
              </div>
            ) : (
              profile && <Videos profile={profile} groupDetails={groupDetails} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
